import InstalacaoOpcao from "@/views/Instalacao/Opcoes.vue";
import InstalacaoPassoAPasso from "@/views/Instalacao/PassoAPasso.vue";

export default [
	{
		path: "/suporte/instalacao/a1-sem-midia",
		name: "a1-sem-midia",
		meta: {
			canonical: "www.spcbrasil.org.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a1-sem-midia",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A1 sem mídia",
					href: "/suporte/instalacao/a1-sem-midia",
				},
			],
			title: "Instalação - A1 Sem mídia",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior. Selecione abaixo a forma de emissão do seu Certificado Digital SPC Brasil e faça o download do assistente de instalação e o manual de instruções",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Para instalação no macOS deve ser utilizado o backup gerado na primeira instalação (realizado no Windows).",
			cards: [
				{
					icon: "/certificacaodigital/images/instalacao/presencial.svg",
					title: "Presencial",
					content: "Instale o Certificado Digital SPC Brasil que foi emitido presencialmente.",
					href: "a1-sem-midia/presencial",
				},
				{
					icon: "/certificacaodigital/images/instalacao/video_conferencia.svg",
					title: "Videoconferência",
					content: "Instale o Certificado Digital SPC Brasil que foi solicitado através da videoconferência.",
					href: "a1-sem-midia/videoconferencia",
				},
				{
					icon: "/certificacaodigital/images/instalacao/wifi.svg",
					title: "Online",
					content: "Instale o Certificado Digital SPC Brasil de forma autônoma, através do seu e-CPF A3 válido.",
					href: "a1-sem-midia/online",
				},
			],
		},
		component: InstalacaoOpcao,
	},
	{
		path: "/suporte/instalacao/a1-sem-midia/presencial",
		name: "a1-sem-midia-presencial",
		meta: {
			canonical: "www.spcbrasil.org.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a1-sem-midia-presencial",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/a1_sem_midia_manual_presencial.pdf",
			vimeoId: "1069292779",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A1 sem mídia",
					href: "/suporte/instalacao/a1-sem-midia",
				},
				{
					label: "emissão presencial",
					href: "/suporte/instalacao/a1-sem-midia/instalacao",
				},
			],
			title: "Instalação - A1 Sem mídia",
			subtitle: "Emissão Presencial",
			linkManualBackup:
				"/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/manual_backup.pdf",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do assistente de instalação e o manual de instruções sobre seu Certificado Digital SPC Brasil.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Para instalação no macOS deve ser utilizado o backup gerado na primeira instalação (realizado no Windows).",
			cards: [
				{
					content: "Pressione o botão <b>“Clique aqui”</b> para acessar o <b>Assistente Certificado Digital</b>. Em seguida, clique em <b>“Começar instalação”</b>",
					button: {
						href: "https://instalacaocertificado-accndl.safewebpss.com.br/",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						label: "Clique aqui",
						target: "_blank"
					},
				},
				{
					content: "Insira o <b>número do protocolo</b> e o <b>número do CPF</b>. Em seguida, clique no botão “Acessar”. Lembre-se que esse processo deve ser feito pelo titular do Certificado Digital;",
				},
				{
					content: "Nesse momento, você receberá o Código de Confirmação no e-mail cadastrado durante a solicitação do certificado. Na tela do assistente, digite o código de 6 dígitos.<br/><br/><b>Atenção:</b> Caso não localize o e-mail, verifique na pasta de spam, lixo eletrônico ou clique na opção Reenviar Código. Em caso de erros, acione o time de SAC CD.",
				},
				{
					content: "Informe a senha (instalação/revogação) gerada no momento da sua validação presencial e clique em <b>“Acessar”</b>",
				},
				{
					content: "Será gerado um Termo de Titularidade. Leia atentamente as informações contidas no documento e clique em <b>“Concordar e assinar”;</b>\
					<br/><br/>\
					<b>Você pode salvar</b> o Termo de Titularidade clicando no ícone de <b>“disquete”.</b>",
				},
				{
					content: "Será necessário cadastrar uma senha do backup (cópia de segurança). Marque a caixa <b>“Estou ciente da necessidade de possuir arquivo .pfx e a senha de backup para realizar a reinstalação do Certificado Digital”</b> e clique em <b>“Avançar”</b>;\
					<br/><br/>\
					<b>Confira os critérios da senha backup (cópia de segurança):</b><br/>• Mínimo de 4 e no máximo 8 caracteres;<br/>• Não pode conter caractere especial (_,!.@*);<br/>• Pode ser alfanumérica;<br/>• Não é possível a recuperação, portanto anote e guarde em um local seguro.",
				},
				{
					content: "Digite a senha do seu backup (cópia de segurança) e clique em <b>“Ok”;</b>",
				},
				{
					content: "Selecione uma pasta em seu computador e <b>salve o arquivo do backup</b> (cópia de segurança). Dê preferência à área de trabalho para localizar o arquivo com facilidade. É importante salvar essa cópia em um pendrive, HD externo ou e-mail;",
				},
				{
					content: "<b>Parabéns!</b> Seu Certificado Digital A1 foi instalado com sucesso.",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
	{
		path: "/suporte/instalacao/a1-sem-midia/videoconferencia",
		name: "a1-sem-midia-videoconferencia",
		meta: {
			canonical: "www.spcbrasil.org.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a1-sem-midia-videoconferencia",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/a1_sem_midia_manual_videoconferencia.pdf",
			vimeoId: "1069293134",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A1 sem mídia",
					href: "/suporte/instalacao/a1-sem-midia",
				},
				{
					label: "videoconferência",
					href: "/suporte/instalacao/a1-sem-midia/videoconferencia",
				},
			],
			title: "Instalação - A1 Sem mídia",
			subtitle: "Videoconferência",
			linkManualBackup:
				"/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/manual_backup.pdf",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do assistente de instalação e o manual de instruções sobre seu Certificado Digital SPC Brasil.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Para instalação no macOS deve ser utilizado o backup gerado na primeira instalação (realizado no Windows).",
			cards: [
				{
					content: "Pressione o botão <b>“Clique aqui”</b> para acessar o <b>Assistente Certificado Digital</b>. Em seguida, clique em <b>“Começar instalação”</b>",
					button: {
						href: "https://instalacaocertificado-accndl.safewebpss.com.br/",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						label: "Clique aqui",
						target: "_blank"
					},
				},
				{
					content: "Insira o <b>número do protocolo</b> e o <b>número do CPF</b>. Em seguida, clique no botão “Acessar”. Lembre-se que esse processo deve ser feito pelo titular do Certificado Digital;",
				},
				{
					content: "Nesse momento, você receberá o Código de Confirmação no e-mail cadastrado durante a solicitação do certificado. Na tela do assistente, digite o código de 6 dígitos.<br/><br/><b>Atenção:</b> Caso não localize o e-mail, verifique na pasta de spam, lixo eletrônico ou clique na opção Reenviar Código. Em caso de erros, acione o time de SAC CD.",
				},
				{
					content: "Informe a senha (instalação/revogação) gerada no momento da sua validação presencial e clique em <b>“Acessar”</b>",
				},
				{
					content: "Será gerado um Termo de Titularidade. Leia atentamente as informações contidas no documento e clique em <b>“Concordar e assinar”;</b>\
					<br/><br/>\
					<b>Você pode salvar</b> o Termo de Titularidade clicando no ícone de <b>“disquete”.</b>",
				},
				{
					content: "Será necessário cadastrar uma senha do backup (cópia de segurança). Marque a caixa <b>“Estou ciente da necessidade de possuir arquivo .pfx e a senha de backup para realizar a reinstalação do Certificado Digital”</b> e clique em <b>“Avançar”</b>;\
					<br/><br/>\
					<b>Confira os critérios da senha backup (cópia de segurança):</b><br/>• Mínimo de 4 e no máximo 8 caracteres;<br/>• Não pode conter caractere especial (_,!.@*);<br/>• Pode ser alfanumérica;<br/>• Não é possível a recuperação, portanto anote e guarde em um local seguro.",
				},
				{
					content: "Digite a senha do seu backup (cópia de segurança) e clique em <b>“Ok”;</b>",
				},
				{
					content: "Selecione uma pasta em seu computador e <b>salve o arquivo do backup</b> (cópia de segurança). Dê preferência à área de trabalho para localizar o arquivo com facilidade. É importante salvar essa cópia em um pendrive, HD externo ou e-mail;",
				},
				{
					content: "<b>Parabéns!</b> Seu Certificado Digital A1 foi instalado com sucesso.",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
	{
		path: "/suporte/instalacao/a1-sem-midia/online",
		name: "a1-sem-midia-online",
		meta: {
			canonical: "www.spcbrasil.org.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a1-sem-midia-online",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/a1_sem_midia_manual_online.pdf",
			vimeoId: "1038599626",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A1 sem mídia",
					href: "/suporte/instalacao/a1-sem-midia",
				},
				{
					label: "online",
					href: "/suporte/instalacao/a1-sem-midia/online",
				},
			],
			title: "Instalação - A1 Sem mídia",
			subtitle: "Online",
			linkManualBackup:
				"/certificacaodigital/docs/suporte/instalacao/a1-sem-midia/manual_backup.pdf",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior. Também deverá estar em posse do seu e-CPF A3  válido e conectado no computador.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Para instalação no macOS deve ser utilizado o backup gerado na primeira instalação (realizado no Windows). Por gentileza, caso possua uma versão antiga do <u>Assistente Certificado Digital</u>, o mesmo deve ser removido para evitar possíveis conflitos e/ou erros na instalação.",
			cards: [
				{
					content: "<strong>Clique em download</strong> e acesse o <strong>Assistente Certificado Digital</strong>, em seguida clique em <strong>Instalar Certificado.</strong>",
					button: {
						href: "https://ferramentas.spc.org.br/InstaladorA1/AssistenteCertificadoDigital.application",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						label: "Download",
					},
				},
				{
					content: "Com seu certificado conectado no computador, digite o <b>protocolo e CPF</b>. Em seguida clique em Enviar.",
				},
				{
					content: "Selecione o seu <b>e-CPF A3 válido</b> e confirme seus dados pessoais.",
				},
				{
					content: "<strong>Cadastre a sua senha de revogação.</strong> Não se esqueça de assinar o termo de titularidade e responsabilidade.",
				},
				{
					content: "<strong>Cadastre a senha do backup</strong> do seu certificado A1 e salve de forma segura.<div class='mt-4'><strong class='text-spc'>Pronto:</strong> seu certificado está pronto para uso!</div>",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
];
